import { userEmailHydrator } from '../../fieldOptions/hydrators'
import groupUserRoles from '../../fieldOptions/groupUserRoles'

export default [
  {
    name: 'Group',
    prop: 'group_id',
    type: 'autocomplete',
    references: 'admin/groups',
    referenceProp: 'name',
    query: {
      order: [{
        column: 'name_length',
        direction: 'asc'
      }]
    }
  },
  { name: 'User', prop: 'user_id', type: 'autocomplete', dataHydrator: userEmailHydrator, references: 'admin/users', referenceProp: 'fullname', displayProp: 'displayVal' },
  { name: 'Role', prop: 'coach_role', type: 'select', options: groupUserRoles }
]
